"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonPagination = void 0;
const React = require("react");
const constants_1 = require("../../utils/constants");
const BronsonPagination = (props) => {
    const [currentPage, setCurrentPage] = React.useState(props.config.currentPage ? props.config.currentPage : constants_1.zero);
    React.useEffect(() => {
        var _a;
        setCurrentPage((_a = props.config.currentPage) !== null && _a !== void 0 ? _a : constants_1.zero);
    }, [props.config.currentPage]);
    const handlePageNavigation = (direction) => {
        let navigateToPage = currentPage;
        if (props.config.totalPages)
            if (direction) {
                navigateToPage++;
                if (navigateToPage >= props.config.totalPages)
                    navigateToPage = props.config.totalPages - constants_1.one;
            }
            else {
                navigateToPage--;
            }
        else {
            navigateToPage = constants_1.zero;
        }
        setCurrentPage(navigateToPage);
        return navigateToPage;
    };
    const handlePreviousPageClick = (event) => {
        event.preventDefault();
        const navigateToPage = handlePageNavigation(false);
        props.config.onPageChange(navigateToPage);
    };
    const handleNextPageClick = (event) => {
        event.preventDefault();
        const navigateToPage = handlePageNavigation(true);
        props.config.onPageChange(navigateToPage);
    };
    const paginationLinkItem = (onClick, linkClassName, tooltip, value = '', key = `bronson-pagination-item-default-${Math.random() * constants_1.tenThousand}`) => {
        return (React.createElement("li", { key: key, className: 'c-pagination__item' },
            React.createElement("a", { href: '#', className: `c-pagination__link ${linkClassName}`, title: tooltip, onClick: onClick }, value)));
    };
    const paginationItem = (value, pageKey, valueClass) => {
        return paginationLinkItem((event) => {
            event.preventDefault();
            setCurrentPage(pageKey);
            props.config.onPageChange(pageKey);
        }, valueClass, '', value, pageKey);
    };
    const renderPreviousPageButton = () => {
        if (props.config.enablePreviousPage !== false) {
            if (currentPage === constants_1.zero) {
                return (React.createElement("li", { className: 'c-pagination__item', id: 'btnPrev' },
                    React.createElement("span", { className: 'c-pagination__link c-pagination__link--stepper-prev u-text-brand is-disabled' },
                        React.createElement("span", { className: 'u-visually-hidden' }))));
            }
            else {
                return paginationLinkItem(handlePreviousPageClick, 'c-pagination__link--stepper-prev', 'Página anterior');
            }
        }
        return React.createElement(React.Fragment, null);
    };
    const renderNextPageButton = () => {
        if (props.config.enableNextPage !== false) {
            if (currentPage === props.config.totalPages - constants_1.one) {
                return (React.createElement("li", { className: 'c-pagination__item' },
                    React.createElement("span", { id: 'btnNext', className: 'c-pagination__link c-pagination__link--stepper-next u-text-brand is-disabled' },
                        React.createElement("span", { className: 'u-visually-hidden' }))));
            }
            else {
                return paginationLinkItem(handleNextPageClick, 'c-pagination__link--stepper-next', 'Siguiente página');
            }
        }
        return React.createElement(React.Fragment, null);
    };
    const renderPaginationItems = () => {
        let isActive = '';
        const paginationItems = [];
        if (props.config.singleNumberPage) {
            paginationItems.push(paginationLinkItem((event) => {
                event.preventDefault();
            }, '', '', props.config.singleNumberPage));
        }
        else {
            for (let i = 0; i < (props.config.totalPages || constants_1.zero); i++) {
                isActive = currentPage === i ? 'is-active' : '';
                paginationItems.push(paginationItem(i + constants_1.one, i, isActive));
            }
        }
        return paginationItems;
    };
    return (React.createElement("nav", { className: 'c-pagination', "aria-label": 'Pagination' },
        React.createElement("ul", { className: 'c-pagination__list' },
            renderPreviousPageButton(),
            renderPaginationItems(),
            renderNextPageButton())));
};
exports.BronsonPagination = BronsonPagination;
